module.exports = __webpack_public_path__ + "img/cz-partners-E15.4753d10d.png";